import {Box, Center, Flex, Icon, Text} from '@chakra-ui/react'
import {useEffect, useState} from 'react'
import Loading from '@components/Loading'
import reviseRequest from '@apis/revise'
import ItemPhrase from '../RevisePage/ItemPhrase'
import BannerRevise from '@assets/images/learn/notebook_banner.png'
import {ReactComponent as ArrowRight4} from '@assets/svgs/learn/arrow_right_4.svg'
import {useLocation, useNavigate} from 'react-router-dom'
import {updateIsShowHeaderBtn} from '@redux/revise/revise'
import {useDispatch, useSelector} from 'react-redux'
import {PATH} from '@utils/Const'
import {Modal} from 'antd'
import appRequest from '@apis/app'
import {getFeedbackOverview} from '@redux/shared/shared'
import mapRequest from '@apis/map'
import GlobalButton from '@components/GlobalButton/GlobalButton'
import ratingLottie from '@assets/lotties/rating.json'
import {Widget} from '@typeform/embed-react'
import Lottie from 'lottie-react'
import {isParamsValid} from '@utils'

const colors = [
  '#F13B32',
  '#FF5E00',
  '#F80',
  '#FF9D00',
  '#FFB700',
  '#FBDA06',
  '#F5C929',
  '#8FD328',
  '#69BF3B',
  '#4CAF4F',
]

const ExerciseComplete = () => {
  const [isLoading, setIsLoading] = useState<any>(true)
  const [phrases, setPhrases] = useState<any>([])
  const navigate = useNavigate()
  const location = useLocation()
  const dispatch: any = useDispatch()
  const {entry_point, phrase_bucket_ids} = location.state || {}
  const {dataFeedbackOverview} = useSelector((state: any) => state.shared)
  const [isShowModalFeedback, setIsShowModalFeedback] = useState<boolean>(false)
  const [step, setStep] = useState<number>(1)
  const [feedbackData, setFeedbackData] = useState<any>()
  const [isShowTypeForm, setIsShowTypeForm] = useState<boolean>(false)

  useEffect(() => {
    if (!isParamsValid([phrase_bucket_ids])) {
      navigate(PATH.HOME)
    }
  }, [])

  useEffect(() => {
    if (!phrase_bucket_ids) return
    getPhrases()
  }, [])

  useEffect(() => {
    if (!dataFeedbackOverview) return
    if (
      entry_point === 'ROADMAP' &&
      !dataFeedbackOverview?.feedback_data?.FINISH_PHRASE_PRACTICE?.is_completed
    ) {
      setIsShowModalFeedback(true)
      getFeedbackData()
    }
  }, [entry_point, dataFeedbackOverview])

  const getPhrases = async () => {
    setIsLoading(true)
    const params = {phrase_bucket_ids}
    const res = await reviseRequest.getSummary(params)
    if (res) {
      if (res.status === 200) {
        setPhrases(res.data.data)
      }
    }
    setIsLoading(false)
  }

  const getFeedbackData = async () => {
    try {
      const params = {
        'feedback-id':
          dataFeedbackOverview?.feedback_data?.FINISH_PHRASE_PRACTICE
            ?.feedback_id || '',
      }
      const res = await mapRequest.getFeedbackData(params)
      if (res) {
        setFeedbackData(res?.data?.data)
      }
    } catch (error) {}
  }

  const handleClickRate = async (score: number) => {
    if (feedbackData?.feedback_data?.typeform_id) {
      setStep(2)
    } else {
      setIsShowModalFeedback(false)
    }
    try {
      const params = {
        feedback_data_id:
          dataFeedbackOverview?.feedback_data?.FINISH_PHRASE_PRACTICE
            ?.feedback_id,
        score: score,
        feature: 'PHRASE_PRACTICE',
      }
      const res = await appRequest.submitFeatureFeedback(params)
      dispatch(getFeedbackOverview())
    } catch (error) {}
  }

  const handleClickSkip = () => {
    setIsShowModalFeedback(false)
  }

  const handleSubmitTypeForm = () => {
    setIsShowModalFeedback(false)
  }

  const handleClick = () => {
    navigate(PATH.LEARN_REVISE_ROOM)
    dispatch(updateIsShowHeaderBtn(false))
  }

  return (
    <Box minH={'100vh'}>
      {/* Header */}
      <Box
        className="HeaderRevise"
        minH={'400px'}
        bgImage={BannerRevise}
        bgRepeat={'no-repeat'}
        bgSize={'cover'}
        borderRadius={'0px 0px 100px 100px'}>
        <Flex
          flexDirection={{base: 'column', md: 'row'}}
          justifyContent={'space-between'}
          pt={{base: '32px', md: '54px'}}
          gap={'16px'}
          maxW={'1280px'}
          mx={'auto'}
          px={{base: '24px', md: '70px'}}>
          <Flex
            flexDirection={'column'}
            textAlign={{base: 'center', md: 'unset'}}
            color={'#002766'}>
            <Text fontSize={{base: '18px', md: '24px'}} fontWeight={600}>
              Chúc mừng bạn đã hoàn thành phần Ôn tập!
            </Text>
            <Text fontSize={{base: '14px', md: '16px'}} mt={'24px'}>
              Cùng xem lại các cụm từ bạn đã hoàn thành nhé
            </Text>
          </Flex>
          <Center>
            {phrases.is_show_continue_practice_button && (
              <Flex
                bg={'#FFA800'}
                p={'12px 24px'}
                borderRadius={'12px'}
                gap={'8px'}
                _hover={{bg: '#ffbb37'}}
                cursor={'pointer'}
                onClick={handleClick}>
                <Text fontSize={'16px'} color={'white'} fontWeight={700}>
                  Ôn tiếp
                </Text>
                <Icon
                  w={'24px'}
                  h={'24px'}
                  sx={{
                    stroke: 'white',
                  }}>
                  <ArrowRight4 />
                </Icon>
              </Flex>
            )}
          </Center>
        </Flex>
      </Box>
      {/* Body */}
      <Box className="container-xl">
        <Flex
          h={{base: 'unset', md: '500px'}}
          mt={{base: '-170px', md: '-200px'}}
          mb={'32px'}
          borderRadius={'20px'}
          bg={'white'}>
          <Box
            className="scroll-bar"
            overflow={'auto'}
            flex={1}
            position={'relative'}>
            {!isLoading ? (
              phrases?.phrases.map((item: any, index: any) => {
                return <ItemPhrase key={index} data={item} type="complete" />
              })
            ) : (
              <Loading />
            )}
          </Box>
        </Flex>
      </Box>
      <Modal
        open={isShowModalFeedback}
        width={'850px'}
        onCancel={() => setIsShowModalFeedback(false)}
        footer={null}>
        <>
          {step === 1 && (
            <Flex flexDirection={'column'} alignItems={'center'} py={'50px'}>
              <Box>
                <Text align={'center'} fontSize={'24px'} fontWeight={600}>
                  {feedbackData?.feedback_data?.text}
                </Text>
                <Text align={'center'} mt={'20px'}>
                  {feedbackData?.feedback_data?.sub_text}
                </Text>
                <Flex mt={'40px'} justifyContent={'center'} gap={'32px'}>
                  {Array.from({
                    length: Number(feedbackData?.feedback_data?.total_score),
                  }).map((_, index) => (
                    <Box
                      key={index}
                      w={'48px'}
                      h={'48px'}
                      position={'relative'}>
                      <Center
                        bg={colors[index]}
                        cursor={'pointer'}
                        borderRadius={'50%'}
                        fontSize={'24px'}
                        fontWeight={600}
                        position={'absolute'}
                        w={'100%'}
                        h={'100%'}
                        color={'white'}
                        opacity={0.4}
                        transition={'all 0.3s'}
                        _hover={{
                          opacity: 1,
                          transform: 'scale(1.2)',
                        }}
                        onClick={() => handleClickRate(index + 1)}>
                        {index + 1}
                      </Center>
                      {(index === 0 || index === 9) && (
                        <Text
                          position={'absolute'}
                          bottom={'-40px'}
                          left={'50%'}
                          transform={'translateX(-50%)'}
                          fontWeight={600}
                          style={{
                            textWrap: 'nowrap',
                          }}>
                          {index === 0
                            ? feedbackData?.feedback_data?.min
                            : feedbackData?.feedback_data?.max}
                        </Text>
                      )}
                    </Box>
                  ))}
                </Flex>
              </Box>
            </Flex>
          )}
          {step === 2 && (
            <Flex flexDirection={'column'} alignItems={'center'} mt={'100px'}>
              <>
                {isShowTypeForm ? (
                  <Box className="typeform-iframe">
                    <Widget
                      id={feedbackData?.feedback_data?.typeform_id}
                      style={{width: '700px', height: '500px'}}
                      onSubmit={handleSubmitTypeForm}
                    />
                  </Box>
                ) : (
                  <>
                    <Box w={'300px'}>
                      <Lottie animationData={ratingLottie} />
                    </Box>
                    <Text
                      fontSize={'24px'}
                      fontWeight={600}
                      textAlign={'center'}>
                      Chúng mình muốn biết ý kiến của bạn
                    </Text>
                    <Text
                      fontWeight={400}
                      mt={'16px'}
                      maxW={'405px'}
                      textAlign={'center'}>
                      Mời bạn tham gia khảo sát sau để giúp chúng mình hiểu hơn
                      về nhu cầu học của bạn
                    </Text>
                    <GlobalButton
                      px={'40px'}
                      py={'22px'}
                      mt={'40px'}
                      borderRadius={'12px'}
                      onClick={() => setIsShowTypeForm(true)}>
                      Làm khảo sát
                    </GlobalButton>
                    <GlobalButton
                      fontSize={'16px'}
                      fontWeight={600}
                      mt={'16px'}
                      color={'#007EF5'}
                      bg={'transparent'}
                      _hover={{
                        bg: '#e3f2ff',
                      }}
                      onClick={handleClickSkip}>
                      Để sau
                    </GlobalButton>
                  </>
                )}
              </>
            </Flex>
          )}
        </>
      </Modal>
    </Box>
  )
}

export default ExerciseComplete
